package fr.frux.shared.data.local

import dev.zacsweers.metro.ContributesTo
import dev.zacsweers.metro.Provider
import dev.zacsweers.metro.Provides
import dev.zacsweers.metro.SingleIn
import fr.frux.core.common.di.AppScope
import fr.frux.core.database.FruxDatabase
import fr.frux.core.database.localDatabaseSupported
import fr.frux.shared.di.IoDispatcher
import kotlinx.coroutines.CoroutineDispatcher

/**
 * Fourniture de la persistance locale des favoris (#61), même motif que
 * [TreeLocalDataSourceModule] : la base n'est déréférencée que si la cible a un driver SQLite,
 * sinon [NoOpFavoriteLocalDataSource] (web = réseau seul).
 */
@ContributesTo(AppScope::class)
interface FavoriteLocalDataSourceModule {
    companion object {
        @Provides
        @SingleIn(AppScope::class)
        fun provideFavoriteLocalDataSource(
            database: Provider<FruxDatabase>,
            @IoDispatcher dispatcher: CoroutineDispatcher,
        ): FavoriteLocalDataSource =
            if (localDatabaseSupported) {
                SqlDelightFavoriteLocalDataSource(database(), dispatcher)
            } else {
                NoOpFavoriteLocalDataSource
            }
    }
}
